import React from "react";
import { Form, Input } from "semantic-ui-react";
import FormLabel from "../../common/FormLabel";
import DateTimePicker from "../../app/DateTimePicker";
import DateTime from "../../../lib/DateTime";

/**
 * Render this component inside a <Form />
 */

interface CaseFormInputDateProps {
  label: string;
  value: string;
  onChange(value: string): void;
  required?: boolean;
  labelWidth?: string;
  placeholder?: string;
}

const CaseFormInputDate = (props: CaseFormInputDateProps) => {
  let { label, labelWidth, required, ...restProps } = props;
  const width = labelWidth || "100px";
  if (!required) {
    required = true;
  } else {
    required = false;
  }

  return (
    <Form.Group inline>
      <Form.Field required = {required}>
        <FormLabel width={width}>{label}</FormLabel>
        <Input>
          <DateTimePicker type="date" {...restProps} />
        </Input>
      </Form.Field>
    </Form.Group>
  );
};

export default React.memo(CaseFormInputDate);
